import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterKommetjie() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-kommetjie",
    name: "Painters Kommetjie",
    location: "Kommetjie, Cape Town",
    rating: 4.9,
    reviews: 169,
    specialties: ["Coastal Properties", "Beach Houses", "Marine-Grade Finishes", "Lighthouse District Homes"],
    image: "https://public.readdy.ai/ai/img_res/a32d5bbbb49f04dec7c65be1e8f5cb7f.jpg",
    verified: true,
    yearsExperience: 17,
    website: "https://painterskommetjie.co.za",
    email: "info@painterskommetjie.co.za",
    phone: "+27 21 555 0143",
    description: "Professional painting services in Kommetjie and surrounding Atlantic Seaboard areas. We specialize in coastal properties and beach houses with expertise in marine-grade finishes that withstand harsh ocean conditions.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Coastal Property Painting",
      "Beach House Painting",
      "Marine-Grade Protective Coatings",
      "Waterproofing Services",
      "Wind & Salt Damage Protection",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Kommetjie", "Noordhoek", "Ocean View", "Scarborough", "Misty Cliffs", "Sun Valley", "Atlantic Seaboard"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Kommetjie%20Cape%20Town%2C%20charming%20beach%20cottage%20with%20fresh%20white%20walls%20and%20Atlantic%20Ocean%20views%2C%20quality%20paint%20finish%2C%20Slangkop%20Lighthouse%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20coastal%20decor%20and%20beach-style%20furniture&width=400&height=300&seq=kommetjie-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Kommetjie%20Cape%20Town%20South%20Africa%2C%20coastal%20cottage%20with%20fresh%20paint%20overlooking%20Atlantic%20Ocean%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20dramatic%20coastline%20setting%20with%20lighthouse%20views%2C%20well-maintained%20beach%20property%20with%20natural%20landscaping&width=400&height=300&seq=kommetjie-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Beach%20house%20painting%20project%20in%20Kommetjie%20Atlantic%20Seaboard%2C%20professional%20painters%20working%20on%20coastal%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20traditional%20beach%20architecture%20with%20ocean%20views%2C%20organized%20work%20site%20with%20painting%20equipment%20and%20materials%2C%20windswept%20coastal%20atmosphere&width=400&height=300&seq=kommetjie-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Kommetjie%20beach%20cottage%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20coastal%20kitchen%2C%20quality%20paint%20finish%20with%20ocean-inspired%20color%20scheme%2C%20bright%20clean%20space%20with%20Atlantic%20views%2C%20professional%20painting%20work%20with%20beach-style%20fixtures%20and%20natural%20materials&width=400&height=300&seq=kommetjie-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20Kommetjie%20beachfront%20cottage%2C%20fresh%20painted%20walls%20in%20serene%20bedroom%2C%20coastal%20design%20with%20ocean%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20beach%20decor%20and%20natural%20lighting%20from%20large%20windows&width=400&height=300&seq=kommetjie-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20coastal%20cottage%20painting%20in%20Kommetjie%20Cape%20Town%2C%20professional%20painters%20applying%20marine-grade%20paint%20to%20beach%20property%2C%20Atlantic%20Ocean%20and%20Slangkop%20Lighthouse%20backdrop%2C%20quality%20exterior%20finish%20with%20wind%20and%20salt%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment%20and%20dramatic%20coastal%20setting&width=400&height=300&seq=kommetjie-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Sarah Mitchell",
        rating: 5,
        comment: "Exceptional work on our Kommetjie beach house! The team understood the extreme coastal conditions and delivered a beautiful, durable finish that has held up perfectly against the Atlantic winds and salt spray. Highly professional service."
      },
      {
        name: "Peter Oosthuizen", 
        rating: 5,
        comment: "Outstanding service from start to finish. They completed our Kommetjie cottage painting on schedule and the quality is superb. The marine-grade finishes are exactly what we needed for this exposed coastal location."
      },
      {
        name: "Jennifer Adams",
        rating: 5,
        comment: "Excellent attention to detail and very experienced with coastal painting challenges. Our beach house looks absolutely stunning and the finish has proven to be incredibly durable in these harsh conditions."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Kommetjie | Professional Coastal & Beach House Painting Services Cape Town | Atlantic Seaboard Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Kommetjie offers professional painting services for coastal properties and beach houses in Kommetjie, Cape Town. Specializing in marine-grade finishes, wind and salt protection, and Atlantic Seaboard properties. Expert coastal painting contractors.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Kommetjie, house painters Kommetjie, coastal painting contractors Cape Town, Atlantic Seaboard painting services, beach house painting, marine-grade finishes');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20coastal%20beach%20house%20in%20Kommetjie%20Cape%20Town%20South%20Africa%2C%20spectacular%20Atlantic%20Ocean%20coastline%20with%20Slangkop%20Lighthouse%20and%20dramatic%20waves%2C%20painters%20in%20clean%20uniforms%20applying%20paint%20with%20brushes%20and%20rollers%2C%20traditional%20beach%20cottage%20architecture%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment%20and%20windswept%20coastal%20setting&width=1200&height=600&seq=kommetjie-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters Kommetjie
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Expert Coastal & Beach House Painting Services
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Kommetjie's most trusted painting contractors specializing in coastal properties and beach houses. With over 17 years of experience serving the Atlantic Seaboard, we deliver exceptional quality and durability using marine-grade materials specifically designed to withstand the extreme coastal conditions of this dramatic oceanfront location.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters Kommetjie</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters Kommetjie, the Atlantic Seaboard's premier painting contractor for coastal residential properties and beach houses. For over 17 years, we have been the trusted choice for homeowners throughout Kommetjie, Noordhoek, Ocean View, Scarborough, and the surrounding Atlantic coastline who demand superior craftsmanship and lasting protection for their properties in one of Cape Town's most dramatically beautiful and challenging coastal environments.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been built on a solid foundation of exceptional quality workmanship, meticulous attention to detail, and an unwavering commitment to customer satisfaction. We understand that living in Kommetjie's exposed coastal environment presents some of the most extreme challenges for property maintenance in the Cape Town area, and we have developed specialized expertise in protecting and beautifying homes exposed to powerful Atlantic winds, salt spray, intense UV radiation, and moisture from the ocean.
                        </p>
                        <p className="leading-relaxed">
                          What truly distinguishes Painters Kommetjie from other painting contractors is our deep understanding of the specific environmental conditions that affect properties along the Atlantic Seaboard, particularly in the Kommetjie area. The combination of powerful south-easterly and north-westerly winds, heavy salt-laden ocean spray, high humidity levels, intense summer sun, and the unique microclimate of this exposed coastal location requires specialized knowledge, premium marine-grade materials, and proven application techniques. Our team has spent years perfecting our methods to ensure that every project we complete not only looks beautiful but also provides maximum protection and longevity in these extreme conditions.
                        </p>
                        <p className="leading-relaxed">
                          We take immense pride in our comprehensive, detail-oriented approach to every painting project. From the moment you contact us for an initial consultation through to the final walk-through inspection, we maintain the highest professional standards at every stage. Our process begins with a thorough assessment of your property's condition, taking into account factors such as existing paint condition, substrate type, exposure to wind and salt spray, sun orientation, and any specific concerns you may have. We then provide detailed recommendations and a transparent, itemized quote with no hidden costs or surprises.
                        </p>
                        <p className="leading-relaxed">
                          Our team of skilled painters are not simply workers applying paint to surfaces; they are experienced craftsmen who take genuine pride in their work and understand the importance of delivering flawless results that can withstand the extreme coastal conditions of the Kommetjie area. Each team member has been carefully selected for their skills, reliability, and commitment to excellence. We invest heavily in ongoing training to ensure our team stays current with the latest techniques, marine-grade products, and industry best practices, including specialized training in extreme coastal environment painting and wind-resistant application methods.
                        </p>
                        <p className="leading-relaxed">
                          Over the years, we have built an impressive portfolio of completed projects throughout the Kommetjie area and Atlantic Seaboard. From charming beach cottages and family homes to luxury coastal properties and contemporary architectural designs, we have successfully completed hundreds of projects of varying sizes and complexity. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of its scope. We treat every home as if it were our own, ensuring that the final result exceeds your expectations and provides the protection needed in this challenging environment.
                        </p>
                        <p className="leading-relaxed">
                          At Painters Kommetjie, we believe in building long-term relationships with our clients based on trust, transparency, and consistently excellent results. Many of our customers have been with us for years, returning for maintenance work, renovations, and new projects. They recommend us to their friends, family, and neighbors because they know they can rely on us to deliver superior quality, honest advice, fair pricing, and the specialized expertise needed for coastal properties every single time. This loyalty and trust is something we never take for granted, and it drives us to maintain our high standards on every project.
                        </p>
                        <p className="leading-relaxed">
                          Our commitment to excellence extends far beyond the quality of our painting work. We understand that having contractors working in and around your coastal home requires a high level of trust and professionalism. That's why we maintain clean, organized work sites, protect your furniture and belongings, respect your property and privacy, work efficiently to minimize disruption to your daily routine, and ensure our team members conduct themselves with the professionalism expected in this close-knit coastal community. We communicate clearly and regularly throughout the project, keeping you informed of progress and addressing any questions or concerns promptly.
                        </p>
                        <p className="leading-relaxed">
                          We use only premium, environmentally responsible paints and materials from leading manufacturers such as Plascon, Dulux, and specialized marine coating suppliers. These products are specifically formulated to provide superior adhesion, durability, and resistance to the extreme coastal conditions found along the Atlantic Seaboard. By investing in the best marine-grade materials available, we ensure that your paint job not only looks stunning on completion day but continues to look great and provide protection for many years to come, even in the face of Kommetjie's challenging coastal environment.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters Kommetjie?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">17+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Nearly two decades of proven excellence in extreme coastal property painting throughout the Atlantic Seaboard.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind and protection.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-star-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Marine-Grade Expertise</h4>
                            <p className="text-gray-600 text-sm">Specialized knowledge in extreme coastal conditions with premium marine-grade materials and wind-resistant techniques.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Exceptional Service</h4>
                            <p className="text-gray-600 text-sm">Clear communication, respect for your property, and unwavering commitment to exceeding expectations.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters Kommetjie proudly serves the Atlantic Seaboard and surrounding coastal areas, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Kommetjie', 'Noordhoek', 'Ocean View', 'Scarborough', 'Misty Cliffs', 'Sun Valley', 'Hout Bay', 'Chapman\'s Peak', 'Slangkop'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters Kommetjie, we offer a complete range of professional painting services specifically designed for extreme coastal properties and beach houses. Our expertise encompasses every aspect of coastal residential painting, from initial consultation and color selection through to meticulous surface preparation, expert application, and thorough final inspection.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Interior Painting Excellence</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your living spaces with our premium interior painting services. We specialize in creating beautiful, durable finishes that enhance your home's aesthetic appeal while providing protection against coastal moisture. Our meticulous surface preparation and expert application techniques ensure flawless results in every room.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living rooms, bedrooms, and family areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Kitchens and bathrooms with moisture-resistant coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, cornices, and architectural features</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Doors, window frames, and trim work</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-building-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Extreme Coastal Exterior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Protect and beautify your property's exterior with our specialized extreme coastal painting services. We use premium marine-grade paints and advanced wind-resistant application techniques specifically designed to withstand powerful Atlantic winds, salt spray, UV radiation, and moisture. Our comprehensive approach includes thorough surface preparation and multiple protective coatings.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior walls with marine-grade protective coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Wind and salt damage protection systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Decks, patios, and outdoor entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Fascias, soffits, and exposed elements</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-drop-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Waterproofing & Protection</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Critical for coastal properties, our comprehensive waterproofing services protect your investment from water damage, mold growth, and structural deterioration. We use advanced waterproofing systems and sealants specifically designed for extreme coastal environments with high wind and salt exposure.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior wall waterproofing and sealing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Roof waterproofing and protective coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Balcony and deck waterproofing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Damp proofing and moisture barrier installation</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-paint-brush-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Specialty Coastal Finishes</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Enhance your property with our range of specialty coatings and decorative finishes designed for coastal environments. From UV-resistant clear coats to textured finishes and custom color matching, we have the expertise and experience to create unique, stunning results that withstand extreme conditions.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant protective clear coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Textured and decorative wall finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Wood staining, sealing, and marine varnishing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Metal coating and rust prevention treatments</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20coastal%20beach%20cottage%20in%20Kommetjie%20Cape%20Town%2C%20Atlantic%20Ocean%20and%20Slangkop%20Lighthouse%20views%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20traditional%20beach%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=kommetjie-sidebar-image&orientation=landscape"
                    alt="Professional painters Kommetjie coastal beach house painting services Cape Town Atlantic Seaboard"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
